<template>
    <div class="bottom_wrap">
        <div v-if="endOfData && !loading" class="button_style">
            no more data
        </div>
        <div v-else class="button_style">
            <v-scale-transition
            mode="out-in"
            origin="center">
                <v-progress-circular
                    :indeterminate="true"
                    color="primary"
                />
        </v-scale-transition>
        </div>
    </div>
</template>

<script>
import TableVerticalScrollDetector from "../event/table-vertical-scroll-detector";
import {gsap} from "gsap";

export default {
    name: "TableInfiniteDetector",
    components: {},
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        endOfData: {
            type: Boolean,
            default: false
        },
        targetId: {
            type: String,
            default: undefined,
        },
        target: undefined, // 실제 스크롤되는 타겟 엘리먼트를 지정할 수 있습니다.
    },
    data() {
        return {
            detector: undefined,
            animWiggle: undefined,
            targetContainer: undefined,
            activeBtn: 1,
        }
    },
    computed: {
        canNext() {
            return !this.endOfData && !this.disabled && !this.loading;
        },
    },
    watch: {
        endOfData(end) {
            console.log(this.endOfData);
            // if (this.detector) this.updateDetector();
        },
        disabled(disabled) {
            // if (this.detector) this.updateDetector();
        },
    },
    mounted() {
        if (this.target) {
            this.targetContainer = this.target;
        } else {
            this.targetContainer = !!this.targetId ? document.getElementById(this.targetId) : this.$el.parentElement;
        }

        console.log(this.targetContainer);
        this.detector = new TableVerticalScrollDetector(this.targetContainer, this.onScroll);

        this.updateDetector(); // 만약 초기에 모두 로드했다면 detector를 off 로 변경해줍니다.
    },
    beforeDestroy() {
        // this.detector.off();
        delete this.detector;
    },
    methods: {
        getContainer() {
            return this.targetContainer;
        },

        onScroll(scrollY, toBottom, visibleHeight) {
            if (toBottom > 50) return; // 스크롤 끝에 도달하지 못함. 단, 음수인 경우 컨텐츠가 컨테이너보다 작습니다.
            if (this.loading) return; // 이미 로딩중 입니다. 다음 이벤트를 발생시키지 않습니다.
            // 다음 호출 가능.
            if (this.canNext) {
                this.$emit('onNext');
            }
            // 다음 호출 불가능
            // 인디캐이터 타겟이 있다면 애니매이션
            else {
                const target = this.$refs.chip && this.$refs.chip.$el;
                if (target) {
                    gsap.fromTo(target, {duration: 0, x: 25}, {duration: 0.5, ease: "elastic.out(1.0, 0.2)", x: 0});
                }
            }
        },
        updateDetector() {
            if (this.endOfData) {
                this.detector.off();
            } else {
                this.detector.on();
            }
        }
    }
}
</script>

<style scoped>
    .bottom_wrap {
        width: 100%;
        height: 40px;
        position: relative;
    }

    .button_style {
        width: 100%;
        height: 100%;
        background-color: #0085FF;
        color: white;
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center
    }
</style>
